import React from 'react';
import './style.css';

import CardList from './Lists/Card';

import CONF from './Conf';

export default function App({ graphqlClient }) {
  const [deviceUuid, language, at, darkMode] = ['deviceUuid', 'language', 'at', 'darkMode'].map((i) => {
    console.log(CONF.queryParam[i]);
    return CONF.queryParam[i];
  });
  const deviceType = CONF.deviceType;
  return graphqlClient ? (
    <div className={darkMode === 'true' ? 'App dark' : 'App'}>
      <CardList {...{ graphqlClient, deviceUuid, deviceType, language, at }} />
    </div>
  ) : (
    <div className={darkMode === 'true' ? 'App dark' : 'App'}>Please try again in a moment.</div>
  );
}
